export const INTERNAL_CALCULATION_LABEL_KEY = 'INTERNAL_CALCULATION';
export const PLANFIX_CALCULATION_LABEL_KEY = 'PLANFIX_CALCULATION';
export const PLANFIX_DEAL_CALCULATION_LABEL_KEY = 'PLANFIX_DEAL_CALCULATION';

export const PROFILE_EMPTY_VALUE = '-';
export const PROFILE_UNKNOWN_INITIAL = '?';
export const PROFILE_SCHEDULE_ENABLED_STATUS = 'ON';
export const PROFILE_STOREKEEPER_ROLE = 'STOREKEEPER';
export const PROFILE_FORBIDDEN_STATUS = 403;
export const PROFILE_EMPTY_TEXT = '';
export const PROFILE_SPACE = ' ';
export const PROFILE_LINE_BREAK = '\n';
export const PROFILE_PERCENT_SUFFIX = '%';
export const PROFILE_NUMBER_TYPE = 'number';
export const PROFILE_ROUTE_USER_ID = 'id';
export const PROFILE_INITIAL_LEARNING_WEIGHT = 0;
export const PROFILE_FIRST_RESPONSE_INDEX = 0;
export const PROFILE_SECOND_RESPONSE_INDEX = 1;
export const PROFILE_FIRST_CHARACTER_INDEX = 0;
export const PROFILE_UNDEFINED_TYPE = 'undefined';

export const PROFILE_COLUMN_CLASSES = {
  FULL: 'col-12',
  PROFILE_WITH_CLOTHING: 'col-lg-5 col-md-12',
  CLOTHING: 'col-lg-7 col-md-12'
};

export const PROFILE_BIOMETRY_FIELDS = {
  GROWTH: 'growth',
  WEIGHT: 'weight',
  CLOTHING_SIZE: 'clothingSize',
  SHOE_SIZE: 'shoeSize'
};

export const PROFILE_CLOTHING_MESSAGE_KEYS = {
  ISSUE_SUCCESS: 'CLOTHING_ISSUE_SUCCESS',
  REJECT_SUCCESS: 'CLOTHING_REJECT_SUCCESS',
  EXTENSION_SUCCESS: 'CLOTHING_EXTENSION_SUCCESS',
  ISSUE_ERROR: 'CLOTHING_ISSUE_ERROR',
  REJECT_ERROR: 'CLOTHING_REJECT_ERROR',
  EXTENSION_ERROR: 'CLOTHING_EXTENSION_ERROR'
};

export const PROFILE_PROBATION_MESSAGE_KEYS = {
  UPDATE_ERROR: 'PROBATION_UPDATE_ERROR',
  REVOKE_REASON_PROMPT: 'PROBATION_REVOKE_REASON_PROMPT',
  TOOLTIP_DESCRIPTION: 'PROBATION_APPROVAL_TOOLTIP_DESCRIPTION',
  PERMISSION_REQUIRED: 'PROBATION_APPROVAL_PERMISSION_REQUIRED'
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile.constants.ts